import React from 'react'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { useStrategyMemoId } from '../hooks/useStrategyMemoId'

export const useRestoringParams = () => {
  const brandAccountId = useBrandAccountId()
  const strategyMemoId = useStrategyMemoId()

  return React.useMemo(
    () => ({
      brandAccountId,
      replace: {
        path: compile('strategyMemoEdit', { brandAccountId, strategyMemoId }),
        state: {},
      },
    }),
    [brandAccountId, strategyMemoId],
  )
}
